module.exports = __webpack_public_path__ + "img/timeline.3afa64cd.svg";